import { WSAlert } from "@wingspanhq/fe-component-library";
import React from "react";

import { RequirementDefinitionTemplate } from "../../routes/RouteCreateRequirementByTemplate/types";

export const AlertBillableRequirement: React.FC<{
  template: RequirementDefinitionTemplate;
  requirementName?: string;
}> = ({ template, requirementName }) => {
  return template.isBillable && template.costPerSubmission ? (
    <WSAlert
      icon="info-circle"
      theme="info"
      title="About billable requirements"
    >
      Contractor(s) assigned with this requirement will be asked to complete the{" "}
      {requirementName || template.name} requirement.
      <br />
      <br />
      {requirementName || template.name} is a billable requirement and will be
      billed to you, the client, at ${template.costPerSubmission} for every
      successful verification.
    </WSAlert>
  ) : null;
};
